<template>
  <div>
    <v-dialog persistent v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this Selection?</v-card-title
        >
        <v-card-text>
          Selection
          <strong v-if="itemToDelete">{{ itemToDelete.name }}</strong> will be
          deleted.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click="cancelDelete">No</v-btn>
          <v-btn color="red darken-1" flat="flat" @click="deleteItem"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-4 px-3 mt-2 pt-5 elevation-0">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-if="this.$store.state.showSearch"
          append-icon="search"
          label="Search "
          single-line
          hide-details
          clearable
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-flex class="display-1 mb-3 mx-0 xs12">
        <!-- User Activity -->
        <!-- <v-spacer></v-spacer> -->
        <v-btn-toggle v-model="mySelections" class="mt-0 ml-0 small">
          <v-btn
            flat
            small
            key="group1"
            class="px-3"
            :input-value="true"
            :value="true"
          >
            <span>My</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group2"
            class="px-3"
            :input-value="false"
            :value="false"
          >
            <span>All</span>
          </v-btn>
        </v-btn-toggle>
        <!-- <v-switch class="right" label="Only my Selections" v-model="mySelections"></v-switch> -->
      </v-flex>

      <!-- v-model="selection_store" -->
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="selections"
        style="border-top: 1px solid #ccc"
        hide-headers
        :search="search"
        item-key="id"
        must-sort
        expand
        :loading="$store.state.loading_lists"
        rows-per-page-text="Selections per page"
        no-results-text="No Selections match the criteria."
        class="elevation-0"
      >
        <template slot="items" slot-scope="props">
          <tr :class="{ black: props.expanded, 'white--text': props.expanded }">
            <!-- <td :class="{title: true, editBG: props.expanded}">{{props.item.created_at}}</td> -->
            <td class="py-0 my-2 title">
              <router-link
                :to="{ name: 'SelectionDetail', params: { id: props.item.id } }"
              >
                {{ props.item.name }}
              </router-link>
            </td>
            <td class="text-xs-center">
              {{ props.item.artworks.length }}
              <!-- <router-link class="mr-3" :to="{ name: 'EditExhibition', params: {id: props.item.id, exhibition: props.item}, path: `/exhibitions/edit/${props.item.id}`}" v-html="props.item.title"></router-link> -->
              <!-- <a v-bind:href="'http://tb-cms.org/exhibitions/edit/' + props.item.id" style="" icon><v-icon small>open_in_new</v-icon></a> -->
            </td>
            <td class="text-xs-center">
              <span class="ml-3 body-1">{{
                format_date(props.item.created_at)
              }}</span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.created_by">{{
                get_user(props.item.created_by)
              }}</span>
              <span v-else>NO USER</span>
            </td>
            <td class="layout right text-xs-right pt-1 pr-0">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn color="black" icon small class="mr-4" v-on="on">
                    <v-icon small color="white">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-tile @click="loadSelection(props.item.artworks)">
                    <v-list-tile-avatar>
                      <v-icon small>apps</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Replace current selection</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="addToSelection(props.item.artworks)">
                    <v-list-tile-avatar>
                      <v-icon small>add</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Add to current selection</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="subtractFromSelection(props.item.artworks)">
                    <v-list-tile-avatar>
                      <v-icon small>remove</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Remove from current selection</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>

              <v-tooltip bottom class="mr-4">
                <template v-slot:activator="{ on }">
                  <v-btn color="black" icon small @click="goToList()" v-on="on">
                    <v-icon small color="white">list</v-icon>
                  </v-btn>
                </template>
                <span>Go to List and load Current Selection</span>
              </v-tooltip>

              <v-tooltip bottom class="mr-4">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="black"
                    icon
                    small
                    @click="openSelectionDetail(props.item)"
                    v-on="on"
                  >
                    <v-icon small color="white">sync</v-icon>
                  </v-btn>
                </template>
                <span>Open selection details and NetX runs</span>
              </v-tooltip>

              <list-action-menu :item="props.item"></list-action-menu>

              <v-btn icon small @click="props.expanded = !props.expanded">
                <!-- <a href="#" @click="props.expanded = !props.expanded" class=""> -->
                <!-- <span>show artworks </span> -->
                <v-icon
                  v-if="!props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_more</v-icon
                >
                <v-icon
                  v-if="props.expanded"
                  :class="{ 'white--text': props.expanded }"
                  >expand_less</v-icon
                >
              </v-btn>
              <!-- </a>  -->
              <v-btn
                v-if="c_user.edit || c_user.delete_rights"
                icon
                small
                @click="showDeleteDialog(props.item)"
              >
                <v-icon class="" color="red" small>delete</v-icon>
              </v-btn>
              <!-- </h3> -->
              <!-- <v-chip v-for="a in props.item.exhibition_artworks" v-bind:key="a.id" small >{{a.id}}</v-chip> -->
            </td>
          </tr>
        </template>

        <template v-slot:expand="props">
          <!-- <v-card-title>
            <v-text-field
              v-model="search[props.item.id]"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title> -->
          <v-data-table
            must-sort
            class="elevation-0"
            :pagination.sync="pagination_related"
            :headers="headers_related"
            :items="table_artworks(props.item.artworks)"
            :search="search_related"
            v-model="selected_related"
            item-key="id"
            no-results-text="No Artworks match the criteria."
          >
            <template slot="items" slot-scope="props_related">
              <tr>
                <td>
                  <v-btn
                    style="width: 20px; height: 20px"
                    round
                    color="red"
                    icon
                    small
                    dense
                    @click="
                      remove_from_selection(
                        props.item.id,
                        props_related.item.id
                      )
                    "
                    hint="Remove From the Selection"
                  >
                    <v-icon small dense color="white">remove</v-icon>
                  </v-btn>
                  <router-link
                    :to="{
                      name: 'EditArtwork',
                      params: {
                        id: props_related.item.id,
                        artwork: props_related.item,
                      },
                      path: `/artworks/edit/${props_related.item.id}`,
                    }"
                    class="body-1"
                  >
                    {{ props_related.item.name }},
                    <strong>{{ props_related.item.title }}</strong
                    >, {{ props_related.item.accession_number }}
                  </router-link>

                  <!-- <v-icon class="ml-2" small>edit</v-icon> -->
                </td>
                <td align="right">{{ props_related.item.accession_number }}</td>
                <!-- <td align="right" class="pr-0 mr-0"> 
                  <v-btn round icon small flat @click="remove_from_selection(props.item.id,props_related.item.id)" hint="Remove From the Selection"> 
                    <v-icon small>remove</v-icon> 
                  </v-btn>
                </td> -->
              </tr>
            </template>
          </v-data-table>

          <!-- <ListRelated :artworks="props.item.artworks"></ListRelated> -->
          <v-flex
            style="background-color: #292929; color: #eee"
            class="px-3 py-1 my-0 elevation-0 xs12"
          >
            <h3 class="font-weight-bold subtitle xs12 flex">&nbsp; &nbsp;</h3>
          </v-flex>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_lists"
            :error="$store.state.load_errors.lists"
            empty-text="No Selections Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="mt-4 mx-4 elevation-0">
      <v-card-title class="pl-4 pt-3" style="">
        <!-- <div>
          <div class="headline"><v-icon class="mr-3">contacts</v-icon> Exhibitions</div>
        </div> -->
        <!-- <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Search in Artists" single-line hide-details v-model="search" ></v-text-field> -->
      </v-card-title>
      <!-- <index-table :items="this.displayedData"></index-table> -->
    </v-card>
  </div>
</template>

<script>
// import axios from '@/utils/apiClient'
import ListRelated from './ListRelated'
import ListActionMenu from '../artworks/ListActionMenu'
import { serverBus } from '../../main'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
// import IndexTable from '@/components/selections/IndexTable'
export default {
  mounted: function () {
    serverBus.$on('setSorting', (a) => {
      this.pagination.sortBy = a
      this.pagination.descending = !this.pagination.descending
    })
    // this.toggleOwnership(this.ownerships[0]);
  },
  data: function () {
    return {
      itemToDelete: {},
      deleteDialog: false,
      // selection_store: [],
      mySelections: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at',
      },
      pagination_related: {
        descending: false,
        // rowsPerPage: 10,
        sortBy: 'last_name',
      },
      search: '',
      search_related: '',
      selected: [],
      selected_related: [],
      headers: [
        { text: 'Title', value: 'name' },
        { text: 'Artworks', value: 'artworks.length', align: 'center' },
        { text: 'Date Created', value: 'created_at', align: 'center' },
        { text: 'Created By', value: 'created_by', align: 'center' },
        { text: '', align: 'right' },
      ],
      headers_related: [
        { text: 'Artwork Title', sortable: true, value: 'title' },
        { text: 'Accession Number', value: 'accession_number', align: 'right' },
        // { text: '', sortable:false, align: 'right' },
        // { text: 'Artist', value: 'artist_name', align: 'right' }
        // { text: 'End', value: 'duration_end', align: 'center', }
        // { text: 'Tags', value: 'tags', sortable: false }
      ],
      table_lists: this.$store.state.lists,
      loading: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: '',
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: '',
    }
  },
  created: function () {
    this.$store.dispatch('loadLists')
    // this.selection_store = this.$store.state.lists
  },
  methods: {
    goToList() {
      this.$router.push({
        name: 'Lists',
        params: { loadCurrent: '1' },
      })
    },
    openSelectionDetail (list) {
      this.$router.push({
        name: 'SelectionDetail',
        params: { id: list.id }
      })
    },
    loadSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', e)
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addToSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', e)
      // }
    },
    subtractFromSelection(e) {
      const artworkIds = e || []
      const currentSelection = this.$store.state.currentSelection || []
      this.$store.dispatch(
        'saveCurrentSelection',
        currentSelection.filter((id) => !artworkIds.includes(id))
      )
    },

    showDeleteDialog(p) {
      this.itemToDelete = p
      this.deleteDialog = true
    },
    deleteItem() {
      const index = this.selections.indexOf(this.itemToDelete)
      var i = this.selections.indexOf(this.itemToDelete)
      // if (i != -1) {
      //   this.selections.splice(i, 1);
      // }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deleteSelection', this.itemToDelete)
      this.itemToDelete = null
      this.deleteDialog = false
    },
    cancelDelete() {
      this.deleteDialog = false
      this.itemToDelete = null
    },
    remove_from_selection(list_id, artwork_id) {
      var list = Object.assign(
        {},
        this.$store.state.lists.find((list) => list.id == list_id)
      )
      list.artworks = list.artworks.filter((a) => a != artwork_id)
      this.$store.dispatch('removeArtworkFromList', {
        l: list_id,
        a: artwork_id,
      })
    },
    table_artworks(as) {
      console.log('table_artworks')
      console.log(as)
      console.log(as)
      let out = Object.assign(
        [],
        this.$store.state.artworks.filter((a) => as.includes(a.id))
      )
      // console.log(out)
      // out = out.sort(dynamicSort('last_name'))
      // console.log(out)
      return out
    },
  },
  computed: {
    selections() {
      // this.c_user.id
      if (this.mySelections) {
        // return this.selection_store.filter(j => j.created_by === this.c_user.id)
        return this.$store.getters.user_lists
      } else {
        return this.$store.state.lists
      }
    },
    // table_lists () {
    // return this.selection_store
    // return this.$store.state.lists
    // },
    filtered() {
      return this.$store.state.filterResults
    },
    title() {
      let title = ''
      // if (this.$route.fullPath == '/artworks/oldMasters') {
      //   title = 'Old Masters'
      // } else
      if (this.$route.fullPath == '/artworks/deaccession') {
        title = 'Deaccessioned'
      } else if (this.$route.fullPath == '/artworks/collection') {
        title = 'TBA21 Collection'
      } else if (this.$route.fullPath == '/artworks/pacFvh') {
        title = 'Private Art Collection FTB'
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Design Collection FTB'
      } else if (this.$route.fullPath == '/artworks/pcFT') {
        title = 'Private Collection FT'
      } else if (this.$route.fullPath == '/artworks/pacMr') {
        title = 'Private Art Collection MR'
      }
      return title
    },
    columns() {
      return this.$store.state.artworkColumns
    },
    processedArtists() {
      let artists = this.resultsArtists
      this.artists.map((artist) => {
        let a = artist
        artist.first_name = a ? a.first_name : 'nema meno'
      })
      return artists
    },
    storedData() {
      let sdata = ''
      if (this.$store.state.filterResults) {
        sdata = this.$store.state.filterResults
      } else {
        sdata = this.filteredData
        // console.log(sdata)
        this.$store.dispatch('postFilterResults', sdata)
      }
      this.displayedData = sdata
      return sdata
    },
    filteredData() {
      let searchString = this.filteredTextArtwork

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return (
            artist.artworks.filter(function (artwork) {
              // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
              return (
                artwork.title
                  .toLowerCase()
                  .indexOf(searchString.toLowerCase()) > -1
              )
            }).length > 0
          )
        })
      } else {
        return this.processedArtists
      }
    },
    filteredArtworks: function () {
      var self = this
      // console.log(self)
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        // console.log(artwork)
        var searchRegex = new RegExp(4, 'i')
        // console.log(searchRegex)
        return searchRegex.test(artwork.ownership)
      })
    },

    // processedArtworks () {
    //   let artworks = this.resultsArtworks
    //   this.artworks.map(artwork => {
    //     let a = artwork
    //     artwork.first_name = a ? a.first_name : 'nema meno'
    //   })
    //   return artworks
    // },
    // filteredArtworks () {
    //   return this.artworks
    //     .filter(this.artworkPassesOwnershipFilter)
    // },

    // return this.processedArtists.filter(function(obj) {
    //   return obj.artworks.title(function(item){
    //     return item.indexOf('a') >= 0;
    //   });
    // });
    // function getResult(filterBy, objList) {
    //   return objList.hightlights.filter(function(obj) {
    //   return obj.queries.some(function(item){
    //     return item.indexOf(filterBy) >= 0;
    //   });
    // });
    // }
    //   const x = 'title',
    //     filter = new RegExp(this.filteredText, 'i')
    //   return this.processedArtists.filter(el => {
    //     if (el[x] !== undefined) { return el[x].match(filter) }
    //     else return true;
    //   })
    // }
  },
  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  components: {
    ListRelated,
    ListActionMenu,
    IndexLoadState,
  },
}
</script>

<style scoped>
h2 {
  padding: 20px 0 0 20px;
  font-weight: 100px;
}
/* a:hover {text-decoration:underline;} */
</style>



// WEBPACK FOOTER //
// src/components/selections/Index.vue